import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import { goBackToHomeButtton } from './NotFound';
import './style.scss'; // Import your CSS file

const Inprogress = () => {
  const location = useLocation(); // Get the location object
  const pathname = location.pathname.split("/").join("");
  return (
    <div className="progress-section">
        <Header/>
      <div className="in-progress">
        <h1>{pathname} section</h1>
        <p className="util-text">🔧 This section is under construction. Stay tuned for updates!</p>
      </div>

      {goBackToHomeButtton()}
    </div>
  );
};

export default Inprogress;
